{
    "coordinates": [
        25.7586931157053,
        -100.85123415791676
    ],
    "tooltip": "Cerro del Pueblo",
    "title": "Cerro del Pueblo Formation",
    "country": "Mexico",
    "period": "Cretaceous",
    "alt": "TODO"
}